/**
 * @Author: Zero
 * @Date: 2025-11-10 09:12:16
 * @Explain: 测试玩家管理模块
 */
export default {
  // 测试人列表
  'TESTER.MANAGE.LIST.CREATE': 'Build the tester pool',
  'TESTER.MANAGE.LIST.CREATE.NEW.TESTER': 'Create testers list',
  'TESTER.MANAGE.LIST.COPY.LINK': 'Invitation link',
  'TESTER.MANAGE.LIST.COPY.LINK.COPY.LINK.SUCCESS': 'Copied successfully',
  'TESTER.MANAGE.LIST.COPY.LINK.COPY.LINK.FAIL': 'Copy link fail',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP':
    'If the invitation process is not configured, the link cannot be copied.',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.TITLE':
    'This link is for the invitation process of players to sign the agreement and bind Discord or Steam. Please contact <span class="account">{ACCOUNT}</span> to complete the configuration of the test link.',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.TEXT':
    'After all invited testers click the invitation link, they will enter the following web page process to complete the invitation process. Both this process and its style can be customized.',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.CONTENT':
    'After all invited testers click the invitation link, they will enter the following web page process to complete the invitation process. Both this process and its style can be customized.',
  'TESTER.MANAGE.PLACEHOLDER.CREATE.ENTER.DESCRIPTION': 'Enter description',
  'TESTER.MANAGE.PLACEHOLDER.CREATE.ENTER.NAME': 'Enter name',
  'TESTER.MANAGE.CREATE.ENTER.NAME': 'Name',
  'TESTER.MANAGE.CREATE.ENTER.DESCRIPTION': 'Description',
  'TESTER.MANAGE.CREATE.VERIFY.NAME': 'Name cannot be empty',
  'TESTER.MANAGE.CREATE.VERIFY.NAME.REPEAT': 'Name entered already exists',
  'TESTER.MANAGE.MODAL.TITLE': 'Create testers list',
  'TESTER.MANAGE.EMPTY': 'Welcome to Playtest Hub.',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.MANAGE': 'Build and manage the tester pool',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.INVITATION':
    'Send test invitations and game redemption codes',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.USER':
    "Obtain testers' Discord and Steam accounts",
  'TESTER.MANAGE.EMPTY.EXAMPLE.CONFIDENTIALITY':
    'Sign the NDA confidentiality agreement online',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.Discord':
    'Automatically add testers to the Discord community',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.EASILY.COMPLETE':
    'SmartLink enables you to easily:',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.SUBTITLE':
    'Centrally manage your testers and create an efficient and organized game testing process.',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.TIPS':
    'From recruitment to collaboration, everything is within SmartLink. Make test management more efficient, communication smoother, and the experience more professional.',
  'TESTER.MANAGE.CONFIGURATION.INFORMATION': 'Configuration information',
  'TESTER.MANAGE.CONFIGURATION.INFORMATION.TAG':
    '{tagName} contact is synchronized to the list in one direction, so removing the tag will not affect the contact data in this list',
  'TESTER.MANAGE.TESTER': 'Testers',
  'TESTER.MANAGE.TESTER.NOT.CONFIG': 'Not configured',
  'TESTER.MANAGE.TESTER.INVITATION.JOURNEY': 'invitation journey',
  'TESTER.MANAGE.TESTER.SYNC': 'Contacts are being added....',
  'TESTER.MANAGE.TESTER.NOT.PLAYER.ADD':
    'Currently, there are no testers on the waitlist. Please add some.',
  'TESTER.MANAGE.TESTER.INVITATIONS.PROGRESS':
    'Invitations are in progress. Please try again later.',
  'TESTER.MANAGE.TESTER.INVITATION.PLEASE.COMPLETE.THE': 'Configure ',
  'TESTER.MANAGE.TESTER.LAST.NOT.INVITED': 'No invitations sent out yet',
  'TESTER.MANAGE.TESTER.LAST.INVITED.AT': 'Last invited by {CONTACT} on {DATE}',
  'TESTER.MANAGE.TESTER.LAST.SAVED.AT': 'Last saved by {CONTACT} on {DATE}',
  'TESTER.MANAGE.TESTER.LAST.STATUS': 'Status:',
  'TESTER.MANAGE.LIST.STATUS.WAITLIST': 'Waiting',
  'TESTER.MANAGE.LIST.STATUS.INVITED': 'Invited',
  'TESTER.MANAGE.LIST.STATUS.ACCEPTED': 'Accepted',
  'TESTER.MANAGE.LIST.STATUS.WAITING': 'Waiting',
  'TESTER.MANAGE.LIST.STATUS.ON.BOARDING': 'Accepted',
  'TESTER.MANAGE.LIST.STATUS.INVITE.LINK': ' Invite link',
  'TESTER.MANAGE.LIST.STATUS.INVITE.EMAIL': 'Invite email',
  'TESTER.MANAGE.LIST.STATUS.ON.BOARDING.EMAIL': 'Accepted email',
  'TESTER.MANAGE.LIST.STATUS.WAITLIST.NOTES':
    'Contact has been added to the testers list.',
  'TESTER.MANAGE.LIST.STATUS.INVITED.NOTES':
    'The invitation email has been sent to the tester.',
  'TESTER.MANAGE.LIST.STATUS.ACCEPTED.NOTES':
    'Tester has accepted the invitation and the email with the key has been sent out.',
  'TESTER.MANAGE.LIST.STATUS.TITLE': 'Status',
  // 测试人列表-按钮相关
  'TESTER.MANAGE.LIST.EDIT': 'Edit',
  'TESTER.MANAGE.LIST.CONFIGURE': 'Configure',
  'TESTER.MANAGE.LIST.VIEW.DETAILS': 'Details',
  // 邀请旅程
  'TESTER.MANAGE.LIST.INVITATION JOURNEY': 'Invitation journey',
  // 旅程状态文本
  'TESTER.MANAGE.LIST.STATUS.EDIT': 'Edit',
  'TESTER.MANAGE.LIST.STATUS.SUSPEND': 'Suspend',
  'TESTER.MANAGE.LIST.STATUS.DETAILS': 'Details',
  'TESTER.MANAGE.LIST.STATUS.REVIEWS.ERROR': 'Reviews error',

  // 测试管理列表
  'TESTER.MANAGE.TEST.LIST.FILTERS.MY.NO.REGION': 'No Regions here',
  'TESTER.MANAGE.TEST.LIST.REGION': 'Regions',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GROUP.TITLE': 'Regions',
  'TESTER.MANAGE.TEST.LIST.REGION.CUSTOM.AREA.GROUP.TITLE': 'Zone',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.L':
    "Create a new zone and move regions from 'Others' to this new zone.<br/>Adjust zones and regions in ",
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.C': 'Region management',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.R': '.',
  'TESTER.MANAGE.TEST.LIST.EDIT.TESTER.CONFIRM.BTN.TEXT': 'Save',
  // 修改测试人列表-标题
  'TESTER.MANAGE.TEST.LIST.EDIT.TESTER.TITLE': 'Edit tester list',
  'TESTER.MANAGE.TEST.LIST.TITLE': 'Testers',
  'TESTER.MANAGE.TEST.LIST.TITLE.NO.TESTERS.YET': 'No testers yet.',
  'TESTER.MANAGE.TEST.LIST.SEARCH.NAME.PLACEHOLDER': 'Search tester Email',
  'TESTER.MANAGE.TEST.LIST.SEARCH.STATUS': 'Status',

  // 邀请按钮
  'TESTER.MANAGE.TEST.LIST.INVITE.WAITING.TESTER': 'Send invitations',
  // 删除相关的按钮
  'TESTER.MANAGE.TEST.LIST.REMOVE.CONTACTS': 'Remove testers',
  'TESTER.MANAGE.TEST.LIST.CONFIRM.REMOVE': 'Confirm Removal',
  // 添加联系人
  'TESTER.MANAGE.TEST.LIST.AddCONTACT': 'Add testers',
  'TESTER.MANAGE.TEST.LIST.DIALOG.HEADER.ADD.TESTER': 'Add testers',
  'TESTER.MANAGE.TEST.LIST.DIALOG':
    'Contacts with the selected tag(s) will be added to this testers list.Contacts who receive this tag afterwards can be added to this testers list by re-adding this tag in this panel.',
  'TESTER.MANAGE.TEST.LIST.DIALOG.SELECT.PLACEHOLDER': 'Select tag(s)',
  // 删除联系人 二次弹窗
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.TITLE':
    'Are you sure to remove testers in batches? ',
  // 删除联系人 二次弹窗内容文本
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.CONTENT':
    '{CONTENTCOUNT} contacts have been selected. After removal, all selected contacts will no longer be synchronized to the list.',
  // 删除联系人 二次弹窗内容文本-确认文本
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.CONFIRM.BTN.TEXT': 'Confirm',
  'TESTER.MANAGE.TEST.LIST.DIALOG.SELECTED.PLAYERS':
    '<b>{CONTACTS} tester(s)</b> have been selected.',
  // 同步联系人 message
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT': '{CONTACT} contacts have been added',
  'TESTER.MANAGE.TEST.LIST.SYNC.ZERO.CONTACT':
    'There are no subscribed contacts that can be newly added under this tag.',
  'TESTER.MANAGE.TEST.LIST.DISABLED.TOOLTIP.ADDING':
    'Contacts are being added....',
  // 同步联系人百分比
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.PROGRESS': 'Data reading',
  // 确认邀请按钮文案
  'TESTER.MANAGE.TEST.LIST.CONFIRM.INVITATION': 'Confirm invitation',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION':
    'Invite testers in the "waitlist" status',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.SUBSCRIBERS.ON.THE.WAITLIST':
    'Subscribers on the waitlist',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.SUBSCRIBERS': 'Subscribers',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT':
    'After confirmation, the subscribed test players for this invitation will enter the invitation journey. Please confirm the journey configuration.',
  // 旅程详情跳转
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT.JOURNEY.DETAILS':
    'Journey Details',
  // 表头相关
  'TESTER.MANAGE.TEST.LIST.TABLE.SUBSCRIPTION.STATUS': 'Subscription status',
  'TESTER.MANAGE.TEST.LIST.TABLE.REGION': 'Region',
  'TESTER.MANAGE.TEST.LIST.TABLE.LANGUAGE': 'Language',
  'TESTER.MANAGE.TEST.LIST.TABLE.AUTHORIZATION.PLATFORM':
    'Authorization platform',
  'TESTER.MANAGE.TEST.LIST.TABLE.JOINED.LIST': 'Date added',
  'TESTER.MANAGE.TEST.LIST.TABLE.INVITED.TIME': 'Invitation sent',
  'TESTER.MANAGE.TEST.LIST.TABLE.START.TIME': 'From',
  'TESTER.MANAGE.TEST.LIST.TABLE.END.TIME': 'Until',
  'TESTER.MANAGE.TEST.LIST.TABLE.STATUS': 'Status',
  'TESTER.MANAGE.TEST.LIST.TABLE.EMAIL': 'Email',
  'TESTER.MANAGE.TEST.LIST.TABLE.SUBSCRIBED': 'Subscribed',
  'TESTER.MANAGE.TEST.LIST.TABLE.PENDING': 'Pending',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNSUBSCRIBED': 'Unsubscribed',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNKNOWN': 'Non-subscribed',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNBOUND': 'Unbound',
  'TESTER.MANAGE.TEST.LIST.TABLE.DRAFT': 'Draft',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONGOING': 'Ongoing',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONGOING.JOURNEY.ERROR':
    'Ongoing journey error',
  'TESTER.MANAGE.TEST.LIST.TABLE.SUSPENDED': 'Suspended',
  'TESTER.MANAGE.TEST.LIST.TABLE.TOTAL.COUNT': 'Total testers:{recordCount}',
  // 请求相关的提示
  'TESTER.MANAGE.TEST.LIST.INVITATION.COMPLETE': 'Invitation sent',
  'TESTER.MANAGE.TEST.LIST.INVITATION.FAILED': 'Invitation failed to send',
  'TESTER.MANAGE.TEST.LIST.DELETE':
    '{deleteTesterNums} testers have been successfully removed.',
  'TESTER.MANAGE.TEST.LIST.EDIT.INFO': 'Edit succeed',
  'TESTER.MANAGE.TEST.LIST.IMPORT.CONTACT': 'Success',
  'TESTER.MANAGE.TEST.LIST.CREATED.INFO': 'Success',
  'TESTER.MANAGE.TEST.LIST.PLAYER ENTERED INVITATION JOURNEY':
    'Player entered invitation journey',

  // 测试配置
  'TESTER.MANAGE.CONFIG.EDIT.NAME': 'Edit name & description',
  'TESTER.MANAGE.CONFIG.SELECT.CONTACTS.LABEL':
    '1、Includes contacts who match all selected tags.',
  'TESTER.MANAGE.CONFIG.SELECT.CONTACTS.PLACEHOLDER':
    '标签下的联系人会自动加入到测试列表',
  'TESTER.MANAGE.CONFIG.TEST': '2、Test configure',
  'TESTER.MANAGE.CONFIGURED': '已配置',
  'TESTER.MANAGE.NOT.CONFIGURED': '未配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.TITLE': '受邀流程配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.DESC':
    '此链接提供协议签署、绑定disord 或 steam的玩家受邀流程，请联系 XXXX@XXXX.com完成测试链接配置。',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.LINK.COPY': '复制链接',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.TITLE': '邀请邮件配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.DESC':
    '请将第一步配置好的受邀流程链接粘贴到邮件模板中。<br/>联系人通过邀请邮件，接受测试邀请。',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.SENTING.TIPS':
    'The email is being sent; settings cannot be changed',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.TITLE': '资源码邮件配置',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.DESC':
    '联系人通过邀请邮件，接受测试邀请。<br/>联系人接受邀请，完成邀请流程后，系统会自动为联系人发送资源码邮件。',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.NUM': '资源码数量：{num}',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.UPLOAD': '上传',
  'TESTER.MANAGE.CONFIG.LEAVE.TITLE':
    'Do you want to save the changes you have made?',
  'TESTER.MANAGE.CONFIG.LEAVE.DESC':
    'Here is subtitle description description description description',
  'TESTER.MANAGE.CONFIG.SAVE.TITLE': 'Confirm to save the configuration?',
  'TESTER.MANAGE.CONFIG.SAVE.DESC':
    '<p>Confirm and save the configuration; contacts within the tags will be automatically synchronized to the configuration management page.</p><p style="margin-top: 16px;">You can enter the configuration management page to send invitations to contacts</p>',
  'TESTER.MANAGE.CONFIG.SAVE.GO.TESTER': 'Save and return test list',
  'TESTER.MANAGE.CONFIG.SAVE.GO.TEST': 'Save and enter test management',

  /** 删除弹窗 */
  'TESTER.MANAGE.DELETE.TITLE': 'Confirm deletion of testers list?',
  'TESTER.MANAGE.DELETE.DESC':
    'After deleting {tester}, the  testers list cannot be recovered.',
};
